<template>
    <div class="nav-main" v-if="setup != 0">
        <ul class="list-unstyled nav">
           <li v-for="(nav,index) in setup.main_page_navigation">    
                <a :href="'#section-' + nav.href" 
                v-scroll-to="{
                    el: '#section-' + nav.href,
                    offset: 0
                }">
                    {{nav.name}}
                </a>
            </li>
            <!-- <li v-for="(nav,index) in setup.main_page_navigation.slice(3, 7)">
                <a :href="'#section-' + nav.href" 
                v-scroll-to="{
                    el: '#section-' + nav.href,
                    offset: -74
                }">
                    {{nav.name}}
                </a>
            </li> -->
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'nav-main-fixed',
        data () {
            return {
            }
        },
        computed: {
            setup() {
                return this.$store.state.pageSetup
            },
        },
        methods: {
            // disableOverlay() {
            //     this.$store.commit('Open_Sendwich', false);
            //     document.getElementsByTagName('body')[0].classList.remove('overlay-open');
            // }
        },
        created() {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/nav-main/nav-main.scss';
</style>